import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useEffect, useState } from 'react';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useApi } from '@backstage/core-plugin-api';
import { developerPortalSupportAgentApiRef } from '../../api';

export const AlternativeStartPageSidebarItem = () => {
  const api = useApi(developerPortalSupportAgentApiRef);
  const [canRead, setCanRead] = useState(true);

  useEffect(() => {
    api
      .checkPermissions()
      .then(perms => setCanRead(perms.read))
      .catch(() => setCanRead(false));
  }, [api]);

  if (canRead) return null;

  return <SidebarItem icon={HomeOutlinedIcon} to="/" text="Home" />;
};
